import React, { useState } from "react";
import ChartsFields from "./ChartsFields";
import { evaluate, isSet } from "../../../../../utils/commonUtils";
import Icons from "../../../../../components/UI/Icons";
import RadioGroup from "../../../../../components/UI/FormInputs/RadioGroup";
 
const SectionBasedDetails = ({label,labelStyle,rules,fields,footerFields,note,col,fieldProps,formData,changeHandler,updateFormData,readOnly,validation,headerRadio,headerInput,headerSwitch,hideHeader,cardBodyClassName,headerClassName,headerStyle,Toast,Loader,activityId,sendMessageClickHandler,collapsible = false,defaultCollapsed = false})=>{
   const [isCollapsed, setIsCollapsed] = useState(!!defaultCollapsed);
   
   let result = null;
   let action = '';
   if(isSet(rules,[]).length>0){
      const resultData = evaluate(isSet(rules,[]),formData);
      action = resultData.action;
      result = resultData.result;
   }
   if(action===''){
   }else if((action==='SHOW' && result===false) ||  (action==='HIDE' && result===true)){
      return false;
   }
   
   const defaultFieldProps = isSet(fieldProps, {});
 
   // Get header radio value and options
   // Only use default value if the key doesn't exist in formData at all (not just if it's empty)
   const headerRadioDefaultValue = headerRadio && headerRadio.defaultValue ? headerRadio.defaultValue : '';
   const headerRadioValue = headerRadio && headerRadio.name
      ? (formData[headerRadio.name] !== undefined ? formData[headerRadio.name] : headerRadioDefaultValue)
      : '';
   const headerRadioOptions = headerRadio && headerRadio.options ? headerRadio.options : [];
   const headerRadioName = headerRadio && headerRadio.name ? headerRadio.name : '';
   const headerRadioId = headerRadio && headerRadio.id ? headerRadio.id : headerRadioName;
   
    const headerSwitchName = headerSwitch && headerSwitch.name ? headerSwitch.name : '';
    const headerSwitchLabel = headerSwitch && headerSwitch.label ? headerSwitch.label : 'None';
    const headerSwitchValue = headerSwitchName ? (formData[headerSwitchName] ? 1 : 0) : 0;

    const toggleCollapsed = () => setIsCollapsed((prev) => !prev);
    const headerCollapsible = collapsible;

    return(
        <div className={`card ${hideHeader ? 'border-0 shadow-sm' : 'border-0'} mb-2`}>
        {!hideHeader && (
        <div
            className={`d-block card-header p-2 sh_basecardHeader ${headerClassName || ''}`}
            style={{
                position: 'sticky',
                top: '-20px',
                zIndex: '1',
                ...(headerCollapsible ? { cursor: 'pointer' } : {}),
                ...(headerStyle || {}),
            }}
            role={headerCollapsible ? 'button' : undefined}
            tabIndex={headerCollapsible ? 0 : undefined}
            aria-expanded={headerCollapsible ? !isCollapsed : undefined}
            onClick={headerCollapsible ? toggleCollapsed : undefined}
            onKeyDown={
                headerCollapsible
                    ? (e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              toggleCollapsed();
                          }
                      }
                    : undefined
            }
        >
         <div className="d-flex align-items-center justify-content-between">
            <h6 className={`${labelStyle} m-0 text-md`}>
                {label}
            </h6>
            {headerSwitchName ? (
               <div className="form-check d-inline-flex form-switch mb-0" onClick={(e) => e.stopPropagation()}>
                  <label className="form-check-label text-dark font-weight-bold pr-2 mb-0" htmlFor={headerSwitchName + '_header'}>{headerSwitchLabel}</label>
                  <label className="switch mb-0">
                     <input
                        className="form-check-input"
                        type="checkbox"
                        id={headerSwitchName + '_header'}
                        checked={!!headerSwitchValue}
                        readOnly={readOnly}
                        onChange={(e) => changeHandler && changeHandler(headerSwitchName, e.target.checked ? 1 : 0)}
                     />
                     <span className="slider" />
                  </label>
               </div>
            ) : headerRadio && headerRadioOptions.length > 0 ? (
               <div className="d-flex align-items-center" onClick={(e) => e.stopPropagation()}>
                  <RadioGroup
                     name={headerRadioName}
                     id={headerRadioId}
                     value={headerRadioValue}
                     options={headerRadioOptions}
                     changeHandler={(val) => {
                        if(changeHandler && headerRadioName){
                           changeHandler(headerRadioName, val);
                        }
                     }}
                     readOnly={readOnly}
                     className="form-check-input"
                  />
               </div>
            ) : collapsible ? (
               <span className="text-dark" aria-hidden={true}>
                  <i className={`fas fa-chevron-${isCollapsed ? 'down' : 'up'}`} />
               </span>
            ) : null}
            {/* {(isSet(note,null)!==null)?
               <label class="mb-0">
                  {typeof note === 'string'?
                  <>
                     <Icons type='Warning' />
                     <code class="text-danger"> Note: {note}</code>
                  </>:
                  note
                  }
               
               </label>
            :<></>} */}
            
         </div>
           
        </div>
        )}
       <div className={`card-body ${cardBodyClassName || ''} ${isCollapsed ? 'd-none' : ''}`}>
           <div className="row">
            {fields.map((item,itemIndex)=>{
               if (!item) return null;
               const column = isSet(item.col,isSet(col,'col-6'));
               let result = null;
               let action = '';
               let attr={};
               if(isSet(item.rules,[]).length>0){
                  const resultData = evaluate(isSet(item.rules,[]),formData);
                  action = resultData.action;
                  result = resultData.result;
               }
               if(action===''){
               }else if((action==='SHOW' && result===false) ||  (action==='HIDE' && result===true)){
                  return false;
               }else if(action==='ENABLE' && result===true){
                  attr={
                     ...attr,
                     disabled:false
                  }
               }else if(action==='DISABLE' && result===true){
                  attr={
                     ...attr,
                     disabled:true
                  }
                  console.log('DISABLE',attr);

               }else if(action==='REQUIRED' && result===true){
                  attr={
                     ...attr,
                     required:true,
                     disabled:false
                  }
               }else if (action === 'CLEAR' && result === true) {
                  const key = item.name || item.id;
                  if (key && formData[key] !== "") {
                     setTimeout(() => {
                        updateFormData({ [key]: "" });
                     }, 0);
                  }
                  // also disable after clearing
                  attr = {
                     ...attr,
                     disabled: true
                  };
               }
              
               
 
               return(
                  <>
                  <ChartsFields
                     key={itemIndex}
                     column={column}
                     itemIndex={itemIndex}
                     formData={formData}
                     changeHandler={changeHandler}
                     updateFormData={updateFormData}
                     item={{...defaultFieldProps,...item,...attr}}
                     readOnly={readOnly}
                     validation={validation}
                     Toast={Toast}
                     Loader={Loader}
                     activityId={activityId}
                     sendMessageClickHandler={sendMessageClickHandler}
                     />
                     </>
                     
               )
               
               
            })}
           </div>    
           </div>
        {isSet(footerFields, []).length > 0 && (
          <div className="card-footer border-top bg-transparent d-flex justify-content-center py-3">
            {footerFields.map((item, itemIndex) => {
              if (!item) return null;
              const attr = {};
              if (isSet(item.rules, []).length > 0) {
                const resultData = evaluate(isSet(item.rules, []), formData);
                if ((resultData.action === 'SHOW' && resultData.result === false) || (resultData.action === 'HIDE' && resultData.result === true)) {
                  return null;
                }
              }
              return (
                <ChartsFields
                  key={`footer-${itemIndex}`}
                  column=""
                  itemIndex={itemIndex}
                  formData={formData}
                  changeHandler={changeHandler}
                  updateFormData={updateFormData}
                  item={{ ...defaultFieldProps, ...item, ...attr }}
                  readOnly={readOnly}
                  validation={validation}
                  Toast={Toast}
                  Loader={Loader}
                  activityId={activityId}
                  sendMessageClickHandler={sendMessageClickHandler}
                />
              );
            })}
          </div>
        )}                  
     </div>
    )
}
 
export default SectionBasedDetails;